import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface OctoAIIconProps {
  size?: number;
  className?: string;
  animated?: boolean;
}

export const OctoAIIcon: React.FC<OctoAIIconProps> = ({
  size = 20,
  className = '',
  animated = false
}) => {  const { theme: _theme } = useTheme();
  const color = '#374151'; // Gray for better visibility

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`octoai-icon ${animated ? 'octoai-animated' : ''} ${className}`}
    >
      {/* Octopus body */}
      <circle
        cx="12"
        cy="8"
        r="5"
        fill={color}
        opacity="0.9"
      />

      {/* Eyes */}
      <circle cx="10" cy="7" r="1" fill="#fff" />
      <circle cx="14" cy="7" r="1" fill="#fff" />

      {/* Smile */}
      <path
        d="M 9 9 Q 12 10.5 15 9"
        stroke="#fff"
        strokeWidth="0.5"
        fill="none"
      />

      {/* Tentacles */}
      <path
        d="M 7 11 Q 6 14 5 17 Q 4.5 18 5 19"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        className="tentacle-1"
      />
      <path
        d="M 9.5 12 Q 9 15 8.5 18 Q 8 19 8.5 20"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        className="tentacle-2"
      />
      <path
        d="M 12 12.5 Q 12 16 12 19 Q 12 20 12.5 21"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        className="tentacle-3"
      />
      <path
        d="M 14.5 12 Q 15 15 15.5 18 Q 16 19 15.5 20"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        className="tentacle-4"
      />
      <path
        d="M 17 11 Q 18 14 19 17 Q 19.5 18 19 19"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        className="tentacle-5"
      />

      {/* AI Spark */}
      <circle
        cx="18"
        cy="4"
        r="0.5"
        fill={color}
        className="ai-spark"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="20"
        cy="6"
        r="0.3"
        fill={color}
        className="ai-spark"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="0.5s"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="4"
        cy="6"
        r="0.3"
        fill={color}
        className="ai-spark"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

// Simplified version for inline use
export const OctoAIIconSimple: React.FC<OctoAIIconProps> = ({
  size = 20,
  className = ''
}) => {  const { theme: _theme } = useTheme();
  const color = '#374151'; // Gray for better visibility

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`octoai-icon-simple ${className}`}
    >
      <g>
        {/* Simplified octopus shape */}
        <path
          d="M12 3C15.314 3 18 5.686 18 9C18 9.5 17.9 10 17.7 10.4L17 13L16.5 16C16.3 17.1 15.5 18 14.4 18C13.8 18 13.3 17.7 13 17.2C12.7 17.7 12.2 18 11.6 18C11 18 10.5 17.7 10.2 17.2C9.9 17.7 9.4 18 8.8 18C7.7 18 6.9 17.1 6.7 16L6.2 13L5.5 10.4C5.3 10 5.2 9.5 5.2 9C5.2 5.686 7.886 3 12 3Z"
          fill={color}
          opacity="0.9"
        />
        {/* Eyes */}
        <circle cx="10" cy="8" r="0.8" fill="#ffffff" />
        <circle cx="14" cy="8" r="0.8" fill="#ffffff" />
        {/* Additional tentacles */}
        <path
          d="M8 14Q7.5 16 7 18M12 14Q12 16 12 18M16 14Q16.5 16 17 18"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          opacity="0.6"
        />
      </g>
    </svg>
  );
};